<template>
  <div class='sub-page sub-page-leftmenu'>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='board-grid' style="width: 900px;margin:0 auto;">
        <dx-data-grid ref='refBoardGrid'
          :remote-operations="false"
          :data-source='boardInfoList'
          :show-borders = 'true' :showRowLines = 'true' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :row-alternation-enabled="false"
          keyExpr="seqId" @selection-changed="selectionChanged"
          @toolbarPreparing="onToolbarPreparing"
          @row-removed='onRowRemoved'
        >
          <DxSelection mode="single"/>
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxExport
            :enabled="false"
          />
          <DxFilterRow
            :visible="false"
            apply-filter="auto"
          />
          <DxEditing
              :allow-deleting="isCRUD"
              :allow-updating="false"
              :allow-adding="false"
              :use-icons="true"
              mode='popup'
            >
            </DxEditing>
          <DxColumnFixing :enabled="true"/>
          <DxColumn
            :fixed="false"
            caption="#"
            data-field="seqId"
            width="50"
            alignment='right'
            sortOrder="desc"
          />
          <DxColumn
          :allowEditing="true"
          :visible="true"
          caption="제목"
          data-field="제목"
          :min-width="500"
          >
          </DxColumn>
          <DxColumn
          :allowEditing="false"
          :visible="false"
          caption="내용"
          data-field="내용"
          >
          </DxColumn>

          <DxColumn
          :allowEditing="true"
          :visible="true"
          caption="작성자"
          data-field="createdId"
          alignment="center"
          :min-width="100"
          >
            <DxLookup
              :data-source="employeeInfo"
              display-expr="성명"
              value-expr="사번"
            />
          </DxColumn>
          <DxColumn
          :allowEditing="false"
          :visible="true"
          caption="등록일"
          alignment="center"
          data-field="createdTime"
          dataType= "date"
          format="yyyy-MM-dd"
          :min-width="100"
          >
          </DxColumn>
          <DxColumn
            width="90"
            :buttons="editButtons"
            type="buttons"
          />
          <DxMasterDetail
            :enabled="false"
            template="masterDetailTemplate"
          />

          <dx-paging :enabled="true" :page-size="10"/>
          <!-- <DxPager
            :visible="true"
          /> -->
          <dx-scrolling mode="standard" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="single"/>
          <template #masterDetailTemplate="{ data: board }">
            <div class="board-content">
              <DxHtmlEditor
               :value="board.data.내용"
              >
              </DxHtmlEditor>
            </div>
          </template>
        </dx-data-grid>
      </div>
      <DxPopupGen
        :visible.sync="popupregBoard"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-title="true"
        :width="700"
        :height="820"
        title="공지사항 등록"
      >
        <div class="option">
          <span>제 목 :</span>
          <DxTextBox style="padding:4px;"
            :value.sync="title"
            placeholder="Enter title...."
          />
        </div>
        <div class="option" style="margin-top:10px;">
          <span>내 용 :</span>
          <DxHtmlEditor
            :value.sync="content"
            height="600px"
          >
            <DxToolbar>
              <DxItem name="undo"/>
              <DxItem name="redo"/>
              <DxItem name="separator"/>
              <DxItem
                :accepted-values="sizeValues"
                name="size"
              />
              <DxItem name="separator"/>
              <DxItem name="bold"/>
              <DxItem name="italic"/>
              <DxItem name="strike"/>
              <DxItem name="underline"/>
              <DxItem name="separator"/>
              <DxItem name="alignLeft"/>
              <DxItem name="alignCenter"/>
              <DxItem name="alignRight"/>
              <DxItem name="alignJustify"/>
              <DxItem name="separator"/>
              <DxItem name="orderedList"/>
              <DxItem name="bulletList"/>
              <DxItem name="color"/>
            </DxToolbar>
          </DxHtmlEditor>
        </div>
        <div style="margin-top:10px;">
          <DxButton
            width="100%"
            height="36"
            text="저장"
            type="success"
            styling-mode="contained"
            @click="onClickSave"
          />
        </div>

      </DxPopupGen>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxFilterRow, DxExport, DxColumnFixing, DxPaging, DxScrolling, DxMasterDetail, DxLookup,
  DxColumn, DxSorting, DxSearchPanel, DxSelection, DxEditing } from 'devextreme-vue/data-grid'
import {
  DxHtmlEditor,
  DxToolbar,
  DxItem
} from 'devextreme-vue/html-editor'
import DxTextBox from 'devextreme-vue/text-box'
import { DxPopup as DxPopupGen } from 'devextreme-vue/popup'
import DxButton from 'devextreme-vue/button'

export default {
  name: 'boardInfo',
  data: function () {
    return {
      isLoading: false,
      boardInfoList: null,
      selectedRow: null,
      employeeInfo: this.$store.getters.getEmployee,
      editButtons: [
        {
          hint: '수정',
          icon: 'edit',
          onClick: this.onClickBoardEdit
        }, 'delete'
      ],
      popupregBoard: false,
      title: null,
      content: null,
      sizeValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
      fontValues: ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'],
      isUpdateMode: false
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxEditing,
    DxPaging,
    DxColumnFixing,
    DxColumn,
    DxSorting,
    DxSearchPanel,
    DxScrolling,
    DxMasterDetail,
    DxSelection,
    DxHtmlEditor,
    DxLookup,
    DxPopupGen,
    DxTextBox,
    DxToolbar,
    DxItem,
    DxButton
  },
  computed: {
    getWidth () {
      return 0
    }
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.refreshBoardList()
  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    isCRUD (e) {
      return (e.row.data.createdId === this.userInfo.userId ||
        this.userInfo.permission === ConstDef.SYSTEM_ADMIN)
    },
    onClickBoardEdit (e) {
      if (this.userInfo.permission !== ConstDef.SYSTEM_ADMIN && e.row.data.createdId !== this.userInfo.userId) {
        this.$snotify.info('수정 권한이 없습니다.')
        return
      }
      this.$refs.refBoardGrid.instance.clearSelection()
      this.$refs.refBoardGrid.instance.selectRows([e.row.data.seqId], true)
      this.title = e.row.data.제목
      this.selectedRow = e.row.data
      this.title = e.row.data.제목
      this.content = e.row.data.내용
      this.isUpdateMode = true
      this.popupregBoard = true
    },
    onRowRemoved (row) {
      console.log(row)
      this.$_sp.runDeleteSqlProc('게시판', [{ seqId: row.data.seqId }])
        .then(data => {
          this.$snotify.info('삭제 되었습니다.')
        })
    },
    selectionChanged (e) {
      if (e !== null) {
        e.component.collapseAll(-1)
        e.component.expandRow(e.currentSelectedRowKeys[0])
        this.selectedRow = e.selectedRowsData[0]
      }
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            icon: 'plus',
            hint: '공지사항 등록',
            type: 'normal',
            // stylingMode: 'outlined',
            focusStateEnabled: true,
            onClick: (args) => {
              this.title = null
              this.content = null
              this.isUpdateMode = false
              this.popupregBoard = true
            }
          }
        }
      )
    },
    refreshBoardList () {
      this.isLoading = true
      this.$_sp.runFindSqlProc('게시판', null)
        .then(data => {
          this.isLoading = false
          this.boardInfoList = this.$_sp.MakeModel(data)
          console.log(this.boardInfoList)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onClickSave (e) {
      console.log(this.title)
      console.log(this.content)
      if (this.title === null || this.title.length === 0) {
        this.$snotify.info('제목을 입력하여 주세요')
        return
      }
      if (this.content === null || this.title.content === 0) {
        this.$snotify.info('내용을 입력하여 주세요')
        return
      }
      if (this.isUpdateMode) {
        this.updateContent()
      } else {
        this.saveContent()
      }
    },
    saveContent () {
      const param = {
        제목: this.title,
        내용: this.content,
        createdId: this.userInfo.userId,
        updatedId: this.userInfo.userId,
        createdTime: this.$_appLib.getNow()
      }
      this.$_sp.runInsertAndFindSqlProc('게시판', ['제목', 'createdTime'], null, param)
        .then(data => {
          this.boardInfoList.push(this.$_sp.MakeModel(data)[0])
          this.$refs.refBoardGrid.instance.refresh()
          this.popupregBoard = false
          this.$snotify.info('저장 되었습니다.')
        })
    },
    updateContent () {
      this.selectedRow.제목 = this.title
      this.selectedRow.내용 = this.content
      this.selectedRow.updatedId = this.userInfo.userId

      this.$_sp.runUpdateSqlProc('게시판', ['seqId'], null, [this.selectedRow])
        .then(data => {
          this.$refs.refBoardGrid.instance.refresh()
          this.popupregBoard = false
          this.$snotify.info('저장 되었습니다.')
        })
    }

  }
}
</script>

<style lang="scss">
.dx-master-detail-row {
  .dx-master-detail-cell{
    background-color: white!important;
    padding:0!important;
  }
  .dx-htmleditor{
   border: none!important;
  }
}
</style>
